"use client";

import type { ProductDetails } from "@raumagarn/formatters";
import { AddToWishlistButton } from "~/components/ui/AddToWishlistButton";
import { PdpActions } from "~/features/products/ProductDetails/PdpActions";
import { DownloadRecipeLink } from "~/features/products/ProductDetails/PdpActions/variants/Recipe/DownloadRecipeLink";
import {
	DownloadRecipeShowroom,
	PreviewRecipe,
} from "~/features/products/ProductDetails/PdpActions/variants/Recipe/DownloadRecipeShowroom";
import { useCurrency } from "~/lib/hooks/useCentra";
import { useShowroom } from "~/lib/showroom/hooks/useShowroom";
import styles from "./DownloadRecipe.module.css";

export const RecipeActions = ({
	product,
	pdfExists,
}: {
	product: ProductDetails;
	pdfExists: boolean;
}) => {
	return (
		<PdpActions>
			{pdfExists && <DownloadButton product={product} />}
			<AddToWishlistButton productId={product.displayItemId ?? ""} />
		</PdpActions>
	);
};

const DownloadButton = ({ product }: { product: ProductDetails }) => {
	const { user } = useShowroom();
	const { data: currency } = useCurrency();

	if (user) {
		return (
			<div className={styles.buttons}>
				<DownloadRecipeShowroom product={product} />
				<PreviewRecipe product={product} />
			</div>
		);
	}

	if (currency && product.freeRecipe?.includes(currency)) {
		return <DownloadRecipeLink productId={product.uri} />;
	}

	return null;
};
